import { QueryClient } from '@tanstack/react-query';

/**
 * 앱 전역 단일 QueryClient.
 *
 * router 의 `beforeLoad` 가드 (예: 위키 라우트의 auth 확정) 가 hook 바깥에서도
 * 캐시에 접근해야 하므로 main.tsx 에 두지 않고 모듈 싱글톤으로 분리.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});
